/** @format */
const { publicKey } = require("./partner");

module.exports = {
  getIdSetting: {
    apiKey: publicKey,
    flows: {
      docCheck: "luckydays-ca-2",
      fullCheck: "luckydays-ca",
    },
  },
};



// WEBPACK FOOTER //
// ./src/partners/config/ocr.js